import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetMagazinesMutation } from '../apis';
import type { MagazineQueryLinkerSchema } from '../schemas';

export function MagazinesSelect({ disabled, ...props }: FormAsyncComboboxProps<MagazineQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: MagazineQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/magazines/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetMagazinesMutation}
      disabled={disabled}
    />
  );
}
